import Vue from "vue";
import store from "@/store";

Vue.prototype.$res = {
	custom: (width) => store.getters["base/width"] > width,
	small: () => store.getters["base/res"].small,
	xsmall: () => store.getters["base/res"].xsmall
};
